<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class EditPricingRule extends Vue {

  @Prop(Array) tags;

  data = {}

  get columns() {
    return createColumns.call(this);
  }

  async mounted() {
    this.data = await this.$request.get(`/pricing_rules/${this.$route.params.id}`);
  }

  async handleUpdate(data) {
    const id = this.data.id;
    await this.$request.put(`/pricing_rules/${id}`, data);
    this.$router.replace({ name: 'pricing_rules.show', params: { id } });
  }
}
</script>
